import gql from 'graphql-tag';
import { uploadImage } from '../Plot/uploadImage';

const CreateEventMutation = gql`
  mutation ($input: createEventInput!) {
    createEvent(input: $input) {
      id
      name
      plot {
        id
        __typename
      }
      eventLocationId {
        id
        __typename
      }
      eventLocation {
        id
        __typename
      }
      eventDirector {
        id
        __typename
      }
      customLocationDescription
      evidenceCode1
      evidenceCode2
      evidenceCode3
      evidenceCode4
      evidenceCode5
      evidenceCode6
      evidenceCode7
      evidenceCode8
      evidenceCode9
      evidenceCode10
      evidenceUnlock1
      evidenceUnlock2
      evidenceUnlock3
      evidenceUnlock4
      evidenceUnlock5
      evidenceUnlock6
      evidenceUnlock7
      evidenceUnlock8
      evidenceUnlock9
      evidenceUnlock10
      numberOfEvidence
      bypassCode
      suspectsCode
      discountCode
      attendingActors
      eventCode
      dressCode
      eventCatId
      plotImage {
        url
        __typename
      }
      status
      dressCode
      eventDate {
        date
        time
        __typename
      }
      plotIntroduction
      createdAt
      updatedAt
      deletedAt
      __typename
    }
  }
`;
export const createEvent = async ({ client, params }) => {
  //since plotimage has been prepopulated by the selected plot, we can reassign the value
  params.data.plotImage = params.data.plotImage.url;
  if (params.data.plotImage.rawFile) {
    params.data.plotImage = await uploadImage(client, params, true);
  }
  // Transform date string to required object
  const dateTime = params.data.eventDate.split('T');
  params.data.eventDate = {
    date: dateTime[0],
    time: dateTime[1].slice(0, 5),
  };

  // Removes raw image field as schema not accepts it
  delete params.data.image;

  const result = await client.mutate({
    mutation: CreateEventMutation,
    variables: {
      input: { ...params.data },
    },
  });

  return result.data;
};
